import { render, staticRenderFns } from "./ControlItem.vue?vue&type=template&id=b31fcc94&scoped=true"
import script from "./ControlItem.vue?vue&type=script&lang=js"
export * from "./ControlItem.vue?vue&type=script&lang=js"
import style0 from "./ControlItem.vue?vue&type=style&index=0&id=b31fcc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31fcc94",
  null
  
)

export default component.exports